export const escapeCsvValue = (value) => {
  const stringValue = String(value ?? "");
  return `"${stringValue.replace(/"/g, '""')}"`;
};

export const buildCsvContent = (headers, rows, separator = ";") => {
  return [headers, ...rows]
    .map((row) => row.map((value) => escapeCsvValue(value)).join(separator))
    .join("\n");
};

export const downloadCsvFile = ({ headers, rows, filename, separator = ";" }) => {
  const csvContent = buildCsvContent(headers, rows, separator);
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;
  link.click();

  URL.revokeObjectURL(url);
};
